import { type FC } from "react";
import * as styles from "./styles.css";

export const InquiryMessageLabel: FC = () => (
  <span className={styles.label}>質問メッセージも送れます</span>
);
